<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("screen", 2) }}</div>
      <div>
        <!-- || login_user_role_id != 3 -->
        <router-link
          v-if="$can('update', 'Screens') && login_user_role_id != 3"
          class="btn-blue"
          @click.native="goToRoute('/cinema-manager/edit-screen')"
          to
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="screens"
          >{{ $tc("screen", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div
            v-for="(item, index) in Screens"
            :key="index"
            class="col-md-12 py-2"
          >
            <div
              class="row border-bottom"
              v-if="
                item.fieldname !== 'screen_id' &&
                item.fieldname !== 'created_at' &&
                item.fieldname !== 'created_by' &&
                item.fieldname !== 'updated_by' &&
                item.fieldname !== 'updated_at' &&
                item.fieldname !== 'dept_is_active'
              "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
          <div class="col-md-12">
            <table class="table border">
              <thead class="thead-light">
                <tr>
                  <th class="text-center">
                    {{ $tc("seat", 2) }} {{ $tc("type", 1) }}
                  </th>
                  <th class="text-center">
                    {{ $tc("seat", 1) }} Color {{ $t("code") }}
                  </th>
                  <th class="text-center">{{ $t("noofseats") }}</th>
                  <th class="text-center">{{ $t("seatorder") }}</th>
                  <th class="text-center">{{ $tc("status", 1) }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  v-for="(seattype, seattypeIndex) in ScreenSeatDetail"
                  :key="seattypeIndex"
                >
                  <td class="text-center">{{ seattype.sst_seat_type }}</td>
                  <td class="text-center">
                    {{ seattype.sst_seat_color_code }}
                  </td>
                  <td class="text-center">{{ seattype.sst_no_of_seats }}</td>
                  <td class="text-center">{{ seattype.sst_order }}</td>
                  <!-- <td class="text-center">
                    <div
                      v-if="seattype.sst_is_active == 'Y'"
                      class="col-md-9 col-lg-10 col-xl-10"
                    >Active</div>
                    <div v-else class="col-md-9 col-lg-10 col-xl-10">Inactive</div>
                  </td> -->
                  <td class="text-center" v-if="seattype.sst_is_active == 'Y'">
                    Active
                  </td>
                  <td v-else class="text-center">Inactive</td>
                </tr>
              </tbody>
            </table>

            <span
              class="col-md-12 py-2"
              v-if="login_user_role_id === 1"
              v-for="(item, index) in Screens"
              :key="index + item"
            >
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ createDate | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ updateDate | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Screens from "@/helper/formJSONMaster/Screens";

export default {
  data() {
    return {
      login_user_role_id: null,
      tableId: null,
      createDate: "",
      updateDate: "",
      Screens: [
        ...Screens.screens,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: "123456",
          type: "number",
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: true,
          type: "date",
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: true,
          type: "number",
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: true,
          type: "date",
        },
      ],

      Methods: Screens.Methods,
      submitted: false,
      ScreenSeatDetail: [],
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.tableId = id;
      this.getViewList(id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId,
        },
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getViewList: function (id) {
      let payload = {
        s_id: id,
      };
      MasterService.GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              let obj = data.Records[0];
              // console.log("obj :", obj);

              this.Screens.map((x, index) => {
                if (x.fieldname === "created_by") {
                  this.getViewUsersDetails(obj.created_by, index, "Screens");
                  this.createDate = obj.created_at;
                } else if (x.fieldname === "updated_by") {
                  this.getViewUsersDetails(obj.updated_by, index, "Screens");
                  this.updateDate = obj.updated_at;
                } else if (x.type === "radio") {
                  x.fieldvalue = obj.screen_is_active === "Y" ? true : false;
                } else if (x.fieldname === "screen_name") {
                  x.fieldvalue = obj.screen_name;
                } else if (x.fieldname === "screen_no_of_seats") {
                  x.fieldvalue = obj.screen_no_of_seats;
                } else if (x.fieldname === "screen_no_of_cols") {
                  x.fieldvalue = obj.screen_no_of_cols;
                } else if (x.fieldname === "screen_no_of_rows") {
                  x.fieldvalue = obj.screen_no_of_rows;
                } else if (x.fieldname === "cinema_id") {
                  this.getCinemaList(obj.cinema_id, index);
                } else if (x.fieldname === "screen_format_id") {
                  this.getFormatList(obj.screen_format_id, index);
                }
              });
              // console.log("this.Screens :", this.Screens);

              if (data.seattyperesult.length > 0) {
                this.ScreenSeatDetail = data.seattyperesult;

                // console.log("this.ScreenSeatDetail :", this.ScreenSeatDetail);
              }
            }
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaList: function (value, index) {
      let payload = {
        tableName: "ms_cinemas",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            data.Records.filter((x) => {
              if (x.cine_id === value) {
                this.Screens[index].fieldvalue = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getFormatList: function (value, index) {
      let payload = {
        tableName: "ms_movie_formats",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.mf_id === value) {
                this.Screens[index].fieldvalue = x.mf_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    getViewUsersDetails(user_id, index, key) {
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasScreenComponents/viewScreens.vue